/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: XNSjqwwbHvXu
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebTab.module.css"; // plasmic-import: XNSjqwwbHvXu/css

createPlasmicElementProxy;

export const PlasmicWebTab__VariantProps = new Array("bgColor");

export const PlasmicWebTab__ArgProps = new Array(
  "dockSection",
  "tabNav",
  "tabContent",
  "tabDock"
);

const $$ = {};

function PlasmicWebTab__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          dockSection: true
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "bgColor",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.bgColor
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"tabLayout"}
      data-plasmic-override={overrides.tabLayout}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.tabLayout,
        {
          [sty.tabLayoutbgColor_secondary]: hasVariant(
            $state,
            "bgColor",
            "secondary"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"slotTabTopNav"}
        data-plasmic-override={overrides.slotTabTopNav}
        className={classNames(projectcss.all, sty.slotTabTopNav)}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.tabNav
        })}
      </div>
      <div
        data-plasmic-name={"slotTabContent"}
        data-plasmic-override={overrides.slotTabContent}
        className={classNames(projectcss.all, sty.slotTabContent)}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.tabContent
        })}
      </div>
      {(() => {
        try {
          return $props.dockSection;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return true;
          }
          throw e;
        }
      })() ? (
        <div
          data-plasmic-name={"slotTabDock"}
          data-plasmic-override={overrides.slotTabDock}
          className={classNames(projectcss.all, sty.slotTabDock)}
        >
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.tabDock
          })}
        </div>
      ) : null}
    </div>
  );
}

const PlasmicDescendants = {
  tabLayout: ["tabLayout", "slotTabTopNav", "slotTabContent", "slotTabDock"],
  slotTabTopNav: ["slotTabTopNav"],
  slotTabContent: ["slotTabContent"],
  slotTabDock: ["slotTabDock"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebTab__ArgProps,
          internalVariantPropNames: PlasmicWebTab__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebTab__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "tabLayout") {
    func.displayName = "PlasmicWebTab";
  } else {
    func.displayName = `PlasmicWebTab.${nodeName}`;
  }
  return func;
}

export const PlasmicWebTab = Object.assign(
  // Top-level PlasmicWebTab renders the root element
  makeNodeComponent("tabLayout"),
  {
    // Helper components rendering sub-elements
    slotTabTopNav: makeNodeComponent("slotTabTopNav"),
    slotTabContent: makeNodeComponent("slotTabContent"),
    slotTabDock: makeNodeComponent("slotTabDock"),
    // Metadata about props expected for PlasmicWebTab
    internalVariantProps: PlasmicWebTab__VariantProps,
    internalArgProps: PlasmicWebTab__ArgProps
  }
);

export default PlasmicWebTab;
/* prettier-ignore-end */
